export default __webpack_public_path__ + "static/media/Logo_CN.0dee4fc0.png";